import * as React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '@mui/material/Button';
import { IUnitOfMeasureTypeFormValues, unitOfMeasureTypeFormSchema } from '../../../../@types/model/masterData/unitOfMeasureType/unitOfMeasureTypeFormValues';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';

interface IUnitOfMeasureTypeFormProps {
    isLoading : boolean;
    initialValues : IUnitOfMeasureTypeFormValues;
    onSubmit : (values : IUnitOfMeasureTypeFormValues) => void;
    onClose : () => void;
}

const UnitOfMeasureTypeForm = (props : IUnitOfMeasureTypeFormProps) : React.ReactElement => {
    const schema = unitOfMeasureTypeFormSchema;

    const { handleSubmit, control, formState: { isValid, isDirty } } = useForm<IUnitOfMeasureTypeFormValues>({
        defaultValues: props.initialValues,
        resolver: zodResolver(schema),
        mode: 'onChange',
    });

    const { initialValues, onSubmit, onClose, isLoading } = props;

    return (
        <div>
            <CustomReactHookFormDevTools control={control} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={'fdc p10 pt15 pb10'}>
                    <div className={'fdc aic'}>
                        <ControlledTextField
                            className={'mb10 w500'}
                            name={'name'}
                            label={'Name'}
                            control={control}
                            defaultValue={initialValues.name}
                        />
                        <div className={'fdr jcfs mb5'}>
                            <ControlledLabelledCheckBox
                                className={'p0'}
                                name={'isActive'}
                                label={'Is Active'}
                                control={control}
                                defaultValue={initialValues.isActive}
                            />
                        </div>
                        <div className={'fdr flx1 aic jcc mt10'}>
                            <Button
                                className={'cpd mr20'}
                                type={'reset'}
                                onClick={onClose}
                            >
                                CANCEL
                            </Button>
                            <PillButton
                                className={'pl30 pr30'}
                                text={'SAVE'}
                                size={'small'}
                                type={'submit'}
                                color={'secondary'}
                                disabled={!isDirty || !isValid || isLoading}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default UnitOfMeasureTypeForm;
